// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","SeeMore":"Bte3Jg","fadeInFrames":"_1K2HRm"};